import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';

function ProductsCategories () {
    let [ mobile, setMobile ] = useState( false );
    let [ imagesModal, setImagesModal ] = useState( false );
    let [ images, setImages ] = useState( [] );
    let [ title, setTitle ] = useState( "" );

    useEffect( () => {
        window.scrollTo( 0, 0 );
        if ( document.getElementById( "root" ).clientWidth < 600 ) {
            setMobile( true );
        }
    }, [] );

    return (
        <div className='about-container'>
            <Modal
                open={imagesModal}
                centered
                onCancel={() => setImagesModal( false )}
                okButtonProps={{
                    style: {
                        display: "none"
                    }
                }}
                cancelButtonProps={{
                    style: {
                        display: "none"
                    }
                }}
                title={title}
                width={mobile ? "95%" : "60%"}
            >
                <div className='modal-images-container'>
                    {images.map( ( element, index ) => (
                        <img src={element} alt={`index${ index }`} />
                    ) )}
                </div>
            </Modal>
            <div className='products-banner'>
                {!mobile && <img src={require( "../../images/quality/banner.avif" )} alt="quality-banner" height={"100%"} width={"100%"} />}
                {mobile && <img src={require( "../../images/quality/banner-mobile.avif" )} alt="quality-banner" height={"100%"} width={"100%"} />}
                <div className='products-banner-content'>
                    <span>Product Categories</span>
                    <span>Precision Crafted for Aerospace Excellence.</span>
                </div>
            </div>
            <div className='about-header'>
                Discover Our Premium Range Of Fasteners
            </div>
            <div className='about-content'>
                Welcome to Aero Fasteners Pvt. Ltd., where precision meets excellence. Explore our specialized product categories designed to meet the highest standards of the aerospace industry. Each category is crafted with the utmost attention to detail and quality, ensuring optimal performance and reliability.
            </div>
            <div className='about-middle'>
                <div className='hover-image'>
                    <img src={require( "../../images/products/categories/image1.avif" )} alt="quality-middle" height={"100%"} width={"100%"} />
                    {!mobile && <div className='hover-overlay'>
                        <Button onClick={() => {
                            setTitle( "Aerospace Fasteners: Engineered for Excellence" );
                            setImagesModal( true );
                            setImages( [
                                require( "../../images/products/categories/category1/image1.jpg" ),
                                require( "../../images/products/categories/category1/image2.jpg" ),
                                require( "../../images/products/categories/category1/image3.jpg" ),
                                require( "../../images/products/categories/category1/image4.jpg" ),
                                require( "../../images/products/categories/category1/image5.jpg" ),
                                require( "../../images/products/categories/category1/image6.jpg" ),
                                require( "../../images/products/categories/category1/image7.jpg" ),
                                require( "../../images/products/categories/category1/image8.jpg" ),
                                require( "../../images/products/categories/category1/image9.jpg" ),
                                require( "../../images/products/categories/category1/image10.jpg" ),
                                require( "../../images/products/categories/category1/image11.jpg" ),
                                require( "../../images/products/categories/category1/image12.jpg" ),
                                require( "../../images/products/categories/category1/image13.jpg" ),
                                require( "../../images/products/categories/category1/image14.jpg" ),
                                require( "../../images/products/categories/category1/image15.jpg" ),
                                require( "../../images/products/categories/category1/image16.jpg" ),
                                require( "../../images/products/categories/category1/image17.jpg" ),
                                require( "../../images/products/categories/category1/image18.jpg" ),
                                require( "../../images/products/categories/category1/image19.jpg" ),
                            ] )
                        }}>View All Products</Button>
                    </div>}
                </div>
                <div className='about-middle-content'>
                    <div className='about-content-header'>1. Aerospace Fasteners: Engineered for Excellence</div>
                    <div>
                        Unlock the power of superior fastening solutions with our aerospace-grade fasteners. Built to withstand extreme conditions and deliver unparalleled performance, our fasteners are the backbone of every successful aerospace project.
                    </div>
                    <ul>
                        <li><b>Bolts & Screws:</b> Unmatched strength and reliability for critical aerospace applications.</li>
                        <li><b>High-Performance Nuts & Washers:</b> Ensure secure, stable assemblies with our rigorously tested components.</li>
                        <li><b>Durable Rivets & Inserts:</b> Permanent fastening solutions that stand up to vibration and stress.</li>
                    </ul>
                    <div className='about-content-header'>Why Choose Our Fasteners?</div>
                    <ul>
                        <li><b>Industry Standards:</b> Compliant with NAS, ISO, and ASME specifications</li>
                        <li><b>Rigorous Testing:</b> Extensive quality checks for tensile strength, fatigue resistance, and corrosion.</li>
                        <li><b>Tailored Solutions:</b> Custom designs to fit unique aerospace requirements.</li>
                    </ul>
                    <Button onClick={() => {
                        setTitle( "Aerospace Fasteners: Engineered for Excellence" );
                        setImagesModal( true );
                        setImages( [
                            require( "../../images/products/categories/category1/image1.jpg" ),
                            require( "../../images/products/categories/category1/image2.jpg" ),
                            require( "../../images/products/categories/category1/image3.jpg" ),
                            require( "../../images/products/categories/category1/image4.jpg" ),
                            require( "../../images/products/categories/category1/image5.jpg" ),
                            require( "../../images/products/categories/category1/image6.jpg" ),
                            require( "../../images/products/categories/category1/image7.jpg" ),
                            require( "../../images/products/categories/category1/image8.jpg" ),
                            require( "../../images/products/categories/category1/image9.jpg" ),
                            require( "../../images/products/categories/category1/image10.jpg" ),
                            require( "../../images/products/categories/category1/image11.jpg" ),
                            require( "../../images/products/categories/category1/image12.jpg" ),
                            require( "../../images/products/categories/category1/image13.jpg" ),
                            require( "../../images/products/categories/category1/image14.jpg" ),
                            require( "../../images/products/categories/category1/image15.jpg" ),
                            require( "../../images/products/categories/category1/image16.jpg" ),
                            require( "../../images/products/categories/category1/image17.jpg" ),
                            require( "../../images/products/categories/category1/image18.jpg" ),
                            require( "../../images/products/categories/category1/image19.jpg" ),
                        ] )
                    }}>View All Products</Button>
                </div>
            </div>
            <div className='about-middle'>
                {mobile && <img src={require( "../../images/products/categories/image2.avif" )} alt="quality-middle" height={"100%"} width={"100%"} />}
                <div className='about-middle-content' style={{ padding: "0 1rem 0 0" }}>
                    <div className='about-content-header'>2. Precision Machined Components: Crafted to Perfection</div>
                    <div>
                        Experience the precision and reliability of our machined components. Utilizing cutting-edge technology and expert craftsmanship, our components are designed to meet the stringent demands of aerospace engineering.
                    </div>
                    <ul>
                        <li><b>Custom Machined Parts:</b> Precisely engineered to your exact specifications using advanced CAD/CAM techniques.</li>
                        <li><b>High-Precision Turned Components:</b> Perfect for high-accuracy applications requiring exacting tolerances.</li>
                        <li><b>Advanced CNC Machining:</b> High-volume production with consistent quality and precision.</li>
                    </ul>
                    <div className='about-content-header'>What Sets Us Apart?</div>
                    <ul>
                        <li><b>State-of-the-Art Machinery:</b> Multi-axis CNC and precision grinding for superior results.</li>
                        <li><b>Aerospace-Grade Materials:</b> Aluminum, stainless steel, and high-temperature alloys.</li>
                        <li><b>Quality Assurance:</b> Strict adherence to industry standards and detailed inspection processes.</li>
                    </ul>
                    <Button onClick={() => {
                        setTitle( "Precision Machined Components: Crafted to Perfection" );
                        setImagesModal( true );
                        setImages( [
                            require( "../../images/products/categories/category2/dowels.avif" ),
                            require( "../../images/products/categories/category2/hex.avif" ),
                            require( "../../images/products/categories/category2/machine.avif" ),
                            require( "../../images/products/categories/category2/rivets.avif" ),
                        ] )
                    }}>View All Products</Button>
                </div>
                {!mobile && <div className='hover-image'>
                    <img src={require( "../../images/products/categories/image2.avif" )} alt="quality-middle" height={"100%"} width={"100%"} />
                    <div className='hover-overlay'>
                        <Button onClick={() => {
                            setTitle( "Precision Machined Components: Crafted to Perfection" );
                            setImagesModal( true );
                            setImages( [
                                require( "../../images/products/categories/category2/dowels.avif" ),
                                require( "../../images/products/categories/category2/hex.avif" ),
                                require( "../../images/products/categories/category2/machine.avif" ),
                                require( "../../images/products/categories/category2/rivets.avif" ),
                            ] )
                        }}>View All Products</Button>
                    </div>
                </div>}
            </div>
            <div className='about-middle'>
                <div className='hover-image'>
                    <img src={require( "../../images/products/categories/image3.avif" )} alt="quality-middle" height={"100%"} width={"100%"} />
                    {!mobile && <div className='hover-overlay'>
                        <Button onClick={() => {
                            setTitle( "Custom Special Parts: Tailored to Your Needs" );
                            setImagesModal( true );
                            setImages( [
                                require( "../../images/products/categories/category3/image1.avif" ),
                                require( "../../images/products/categories/category3/image2.avif" ),
                                require( "../../images/products/categories/category3/image3.avif" ),
                                require( "../../images/products/categories/category3/image4.avif" ),
                                require( "../../images/products/categories/category3/image5.avif" ),
                                require( "../../images/products/categories/category3/image6.avif" ),
                                require( "../../images/products/categories/category3/image7.avif" ),
                                require( "../../images/products/categories/category3/image8.avif" ),
                                require( "../../images/products/categories/category3/image9.avif" ),
                                require( "../../images/products/categories/category3/image10.avif" ),
                                require( "../../images/products/categories/category3/image11.avif" ),
                                require( "../../images/products/categories/category3/image12.avif" ),
                                require( "../../images/products/categories/category3/image13.avif" ),
                            ] )
                        }}>View All Products</Button>
                    </div>}
                </div>
                <div className='about-middle-content'>
                    <div className='about-content-header'>3. Custom Special Parts: Tailored to Your Needs</div>
                    <div>
                        Transform your aerospace projects with our custom special parts, designed to meet the unique demands of your applications. Whether it's for high-temperature environments or specialized functions, our bespoke solutions deliver performance you can count on.
                    </div>
                    <ul>
                        <li><b>Precision Bushes:</b> Engineered for optimal fit and performance, available in a variety of materials including bronze and composites.</li>
                        <li><b>Bespoke Components:</b> Custom-built to meet exact design specifications and functional needs.</li>
                        <li><b>Specialty Solutions:</b> High-temperature seals, vibration isolators, and other unique parts.</li>
                    </ul>
                    <div className='about-content-header'>Why Our Custom Parts Stand Out?</div>
                    <ul>
                        <li><b>Customized Manufacturing:</b> Tailored processes for your specific design and material needs.</li>
                        <li><b>Comprehensive Testing:</b> Ensuring performance under demanding conditions.</li>
                        <li><b>Flexible Production:</b> Capable of both prototyping and large-scale manufacturing.</li>
                    </ul>
                    <Button onClick={() => {
                        setTitle( "Custom Special Parts: Tailored to Your Needs" );
                        setImagesModal( true );
                        setImages( [
                            require( "../../images/products/categories/category3/image1.avif" ),
                            require( "../../images/products/categories/category3/image2.avif" ),
                            require( "../../images/products/categories/category3/image3.avif" ),
                            require( "../../images/products/categories/category3/image4.avif" ),
                            require( "../../images/products/categories/category3/image5.avif" ),
                            require( "../../images/products/categories/category3/image6.avif" ),
                            require( "../../images/products/categories/category3/image7.avif" ),
                            require( "../../images/products/categories/category3/image8.avif" ),
                            require( "../../images/products/categories/category3/image9.avif" ),
                            require( "../../images/products/categories/category3/image10.avif" ),
                            require( "../../images/products/categories/category3/image11.avif" ),
                            require( "../../images/products/categories/category3/image12.avif" ),
                            require( "../../images/products/categories/category3/image13.avif" ),
                        ] )
                    }}>View All Products</Button>
                </div>
            </div>
            <div className='about-content' style={{ gap: "1rem" }}>
                <div>
                    At Aero Fasteners Pvt. Ltd., we are dedicated to delivering aerospace components that exceed expectations. Our team of specialists is ready to assist you with technical support and customized solutions. For inquiries or more information, please Contact Us.
                </div>
                <div>
                    Elevate your aerospace engineering with our top-tier fasteners, machined components, and custom parts—engineered for performance and designed for success.
                </div>
            </div>
        </div>
    )
}

export default ProductsCategories
